var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-page"},[_c('site-header'),_c('main',{staticClass:"auth-page__main"},[_c('div',{staticClass:"core-container"},[_c('section',{staticClass:"auth-page__card"},[_c('qr-login-panel',{attrs:{"redirect":_vm.redirect},on:{"success":_vm.onLoginSuccess}})],1)])]),_c('site-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }